import { zIndex } from '@mui/material/styles/zIndex';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { processLink } from '../../utils/shortPinItem';

export const takeScreenshotPasswordProtected = createAsyncThunk(
  "screenshot/take-Screenshot-password-protected",
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/screenshots/pass-protected-ss`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);


export const ScreenShotmoveInFolder = createAsyncThunk(
  "screenshot/moveInFolder",
  async ({ token, folderId, id }, { rejectWithValue }) => {


    try {

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/screenshots/folders/move-in-folder`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            screenshotId: id, folderId
          }
        }
      );

      if (response.data.status) {
        // console.log(response.data.response);
        return { id, folderId, response: response.data.response };
      } else {
        return rejectWithValue("Failed to Add in folder");
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data || "Network Error "
      );
    }
  }
);

// Delete Screenshot
export const deleteScreenshot = createAsyncThunk(
  "screenshot/delete-Screenshot",
  async ({ token, screenshotId }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/screenshots`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            id: screenshotId,
          },
        }
      );

      if (response.data.status) {
        // console.log(response.data.response)
        return { id: screenshotId, response: response.data.response };
      } else {
        return rejectWithValue("Failed to delete screenshot");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

// Edit Screenshot
export const editScreenshot = createAsyncThunk(
  "screenshot/edit-Screenshot",
  async ({ token, formData, key }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/screenshots/${key}`,
        formData,
        {
          headers: {

            Authorization: `Bearer ${token}`,
          },
         
        }
      );

      if (response.data.status) {
        return response.data;
      } else {
        return rejectWithValue("Failed to edit screenshot");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

// ✅ Get List of Screenshots
export const getScreenshots = createAsyncThunk(
  "screenshot/get-Screenshot",
  async ({ token, offset = 1, limit, onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/screenshots/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { offset, limit, onlyMy },
        }
      );

      if (response.data.status) {
        return response.data.response;
      } else {
        return rejectWithValue("Failed to fetch screenshots");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Network error"
      );
    }
  }
);

// ✅ Take a Screenshot
export const takeScreenshotLogged = createAsyncThunk(
  "screenshot/take-Screenshot",
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/screenshots/try`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Network error");
    }
  }
);

const initialState = {
  screenshotData: [],
  isLoading: false,
  error: null,
};

const screenshotSlice = createSlice({
  name: "screenshot",
  initialState,
  reducers: {
    resetScreenshotState: (state) => {
      state.screenshotData = [];
      state.isLoading = false;
      state.error = null;
    },
    addDummyScreenshot: (state, action) => {
      state.screenshotData.unshift(action.payload)
    },
    removeDummyScreenshot: (state, action) => {
      state.screenshotData.shift()
    },
    clearScreenShots: (state) => {
      state.screenshotData = []
    },
    removeFromFolderSs: (state, action) => {
      state.screenshotData = state.screenshotData.map((screenshot) => {
        if (screenshot.key === action.payload.key) {
          return { ...screenshot, folderId: null };
        }
        return screenshot;
      });
    },
    togglePinSs: (state, action) => {
      const pin = state.screenshotData.find(item => item.key === action.payload.key);
      if (pin) {
        pin.pin = !pin.pin;
      }

      state.screenshotData = processLink(state.screenshotData);

    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(takeScreenshotLogged.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(takeScreenshotLogged.fulfilled, (state, action) => {
        state.isLoading = false;
        state.screenshotData.unshift(action.payload);
        toast.success("Screenshot created successfully!");
      })
      .addCase(takeScreenshotLogged.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        toast.error(action.payload || "Failed to take screenshot.");
      })

      // 🔥 Get Screenshots
      .addCase(getScreenshots.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getScreenshots.fulfilled, (state, action) => {
        state.isLoading = false;
        const { offset } = action.meta.arg;

        if (offset === 1) {
          state.screenshotData = []
          state.screenshotData = processLink(action.payload);
        } else {

          const combined = [...state.screenshotData, ...action.payload];
          const unique = Array.from(new Map(combined.map(shot => [shot.key, shot])).values());
          state.screenshotData = processLink(unique);
        }
        // toast.success("Screenshots loaded successfully.");
      })
      .addCase(getScreenshots.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;

        // toast.error(action.payload || "Failed to fetch screenshots.");
      })

      // 🔥 Edit Screenshot
      .addCase(editScreenshot.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(editScreenshot.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.response);
      })
      .addCase(editScreenshot.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        toast.error(action.payload || "Failed to edit screenshot.");
      })


      .addCase(deleteScreenshot.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteScreenshot.fulfilled, (state, action) => {
        state.isLoading = false;
        // Remove deleted screenshot from the state
        state.screenshotData = state.screenshotData.filter(
          (screenshot) => screenshot.screenshotId !== action.payload.id
        );
        toast.success(action.payload.response);
      })
      .addCase(deleteScreenshot.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        toast.error(action.payload || "Failed to delete screenshot.");
      })
      .addCase(ScreenShotmoveInFolder.pending, (state, action) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(ScreenShotmoveInFolder.fulfilled, (state, action) => {
        state.isLoading = false
        const screenshot = state.screenshotData.find(
          (screenshot) => screenshot.screenshotId === action.payload.id)
        if (screenshot) {
          screenshot.folderId = action.payload.folderId;
        }
        toast(action.payload.response)
      })
      .addCase(ScreenShotmoveInFolder.rejected, (state, action) => {
        state.isLoading = false
        toast(action.payload)
      })
      .addCase(takeScreenshotPasswordProtected.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(takeScreenshotPasswordProtected.fulfilled, (state) => {
        state.isLoading = true;
        state.error = null;
        toast.success("Screenshot taken successfully!");
      }).addCase(takeScreenshotPasswordProtected.rejected, (state) => {
        state.isLoading = true;
        state.error = null;
        toast.error("Failed to take screenshot. Please try agian later.");
      })
  },
});

export const { resetScreenshotState, addDummyScreenshot, removeDummyScreenshot,togglePinSs, clearScreenShots, removeFromFolderSs } = screenshotSlice.actions;
export default screenshotSlice.reducer;
